import React, { useState, useEffect } from 'react';
import { ChakraProvider, useToast } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './pages/DashboardLayout';
import LoginPage from './pages/LoginPage';
// import ProtectedRoute from './components/common/ProtectedRoute'; // No longer needed
import { getBusinessIdentifier } from './utils/auth';
import { authService } from './services/authService'; // Import authService
import theme from './theme'; // Import the theme
import ChatBot from './components/ChatBot';
import BackgroundPdfUploadTrigger from './components/BackgroundPdfUploadTrigger';

function App() {
  // Initialize isAuthenticated state based on token presence
  const [isAuthenticated, setIsAuthenticated] = useState(authService.isAuthenticated());
    const toast = useToast();

  // Ensure business identifier from URL is processed on mount
  useEffect(() => {
    const identifier = getBusinessIdentifier();
    if (identifier) {
      console.log(`[App] Business identifier found/set: ${identifier}`);
      // Update state if you need to store it in App.tsx state for other purposes
      // setBusinessId(identifier); 
    } else {
      console.log('[App] No business identifier found in URL or localStorage initially.');
    }
    // Optional: Add listener for logout events if needed
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
    // Navigation will be handled within LoginPage upon successful login
  };

  const handleLogout = () => {
    authService.logout(); // Clear token from service/localStorage
    setIsAuthenticated(false);
    // Navigate to login? Handled by conditional rendering below.
  };

const handleLogoutAll = () => {  
  try {
    authService.logoutAllSalesPerson();
    toast({
      title: 'Success',
      description: 'All salespersons have been logged out successfully.',
      status: 'success',
      duration: 4000,
      isClosable: true,
      position: 'top',
    });
  } catch (error) {
    toast({
      title: 'Error',
      description: 'Failed to log out all salespersons. Please try again.',
      status: 'error',
      duration: 5000,
      isClosable: true,
      position: 'top',
    });
  }
};

  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Routes>
          {!isAuthenticated ? (
            // If not authenticated, only allow access to LoginPage
            <>
              <Route path="/login" element={<LoginPage onLoginSuccess={handleLogin} />} />
              {/* Redirect any other path to /login */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </>
          ) : (
            // If authenticated, render the DashboardLayout which contains all other routes
            // Pass handleLogout to the layout if it has a logout button
            <Route path="/*" element={<DashboardLayout onLogout={handleLogout} onLogoutAll={handleLogoutAll} />} />
          )}
        </Routes>
        {isAuthenticated && <ChatBot businessIdentifier={getBusinessIdentifier() || ""} />} {/* Conditionally render ChatBot only when authenticated and email is aayush@convrse.ai */}
        {/* {isAuthenticated && <BackgroundPdfUploadTrigger />} */}
      </Router>
    </ChakraProvider>
  );
}

export default App;
